/* Yours Truly, Almonds. Shared behaviour for every page. */
(function () {
  'use strict';

  /* ---- mobile navigation drawer ---- */
  var ham = document.querySelector('.ham'),
      drawer = document.getElementById('drawer'),
      scrim = document.getElementById('scrim'),
      closeBtn = document.getElementById('drawer-close');

  function setDrawer(open) {
    if (!drawer || !scrim) return;
    drawer.classList.toggle('on', open);
    scrim.classList.toggle('on', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (ham) ham.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { var f = drawer.querySelector('a, button'); if (f) f.focus(); }
    else if (ham) ham.focus();
  }
  if (ham) ham.addEventListener('click', function () { setDrawer(!drawer.classList.contains('on')); });
  if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('on')) setDrawer(false);
    var lb = document.getElementById('lightbox');
    if (lb && lb.classList.contains('on')) lb.classList.remove('on');
  });

  /* ---- drag to peel: models the actual mechanism ---- */
  var peel = document.getElementById('peel-widget'),
      range = document.getElementById('peel-range');
  if (peel && range) {
    var setX = function (v) {
      v = Math.max(0, Math.min(100, v));
      peel.style.setProperty('--x', v + '%');
      range.value = v;
    };
    range.addEventListener('input', function () { setX(+range.value); });
    var dragging = false;
    var at = function (e) {
      var r = peel.getBoundingClientRect();
      setX((((e.touches ? e.touches[0].clientX : e.clientX) - r.left) / r.width) * 100);
    };
    peel.addEventListener('pointerdown', function (e) { dragging = true; at(e); });
    window.addEventListener('pointermove', function (e) { if (dragging) at(e); });
    window.addEventListener('pointerup', function () { dragging = false; });

    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      var hinted = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting || hinted) return;
          hinted = true;
          var t0 = null;
          requestAnimationFrame(function step(ts) {
            if (!t0) t0 = ts;
            var p = Math.min((ts - t0) / 1100, 1);
            setX(50 + Math.sin(p * Math.PI) * 22);
            if (p < 1) requestAnimationFrame(step);
          });
        });
      }, { threshold: 0.55 }).observe(peel);
    }
  }

  /* ---- quantity steppers, clamped with real bounds ---- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var out = q.querySelector('.q'),
        minus = q.querySelector('[data-step="-"]'),
        plus = q.querySelector('[data-step="+"]');
    var sync = function () {
      var n = parseInt(out.textContent, 10) || 1;
      if (minus) minus.disabled = n <= 1;
      if (plus) plus.disabled = n >= 20;
    };
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(out.textContent, 10) || 1;
        n += (b.dataset.step === '+') ? 1 : -1;
        out.textContent = Math.max(1, Math.min(20, n));
        sync();
      });
    });
    sync();
  });

  /* ---- product hero: the whole field drifts on scroll, over the per-almond float ---- */
  var field = document.getElementById('fly-field');
  if (field && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var fTick = false;
    var drift = function () {
      field.style.transform = 'translate3d(0,' + ((window.scrollY || 0) * 0.16).toFixed(1) + 'px,0)';
      fTick = false;
    };
    window.addEventListener('scroll', function () {
      if (!fTick) { fTick = true; requestAnimationFrame(drift); }
    }, { passive: true });
    drift();
  }

  /* ---- sticky buy/shop bar ----
     Scroll-driven, not an IntersectionObserver: an IO with threshold 0 never fires when an
     element passes from below the viewport to above it without ever intersecting (fast scroll,
     anchor jump, restored position), which left the bar permanently hidden. */
  var stickyBar = document.getElementById('sticky'),
      stickyAfter = document.querySelector('.pdp-buy .qtyrow') || document.querySelector('.phero .hero-cta');
  if (stickyBar && stickyAfter) {
    var sTick = false;
    var syncSticky = function () {
      stickyBar.classList.toggle('on', stickyAfter.getBoundingClientRect().bottom < 0);
      sTick = false;
    };
    window.addEventListener('scroll', function () {
      if (!sTick) { sTick = true; requestAnimationFrame(syncSticky); }
    }, { passive: true });
    window.addEventListener('resize', syncSticky, { passive: true });
    syncSticky();
  }

  /* ---- scroll reveal: fast, once, subtle ---- */
  var revs = document.querySelectorAll('.rev-up');
  if (revs.length) {
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var ro = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('seen'); ro.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revs.forEach(function (el) { ro.observe(el); });
    } else {
      revs.forEach(function (el) { el.classList.add('seen'); });
    }
  }

  /* ---- delivery date promise: a date, not a duration ---- */
  var dp = document.getElementById('date-promise');
  if (dp) {
    var fmt = function (d) {
      return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    };
    var now = new Date();
    var disp = new Date(now); disp.setDate(disp.getDate() + 2);
    var del = new Date(now); del.setDate(del.getDate() + 7);
    dp.innerHTML = '<b>Order today</b> and it is dispatched by <b>' + fmt(disp) + '</b>, delivered by <b>' + fmt(del) + '</b> for most pincodes.';
  }


  /* ================= cart, Shopify AJAX =================
     /cart/add.js, /cart/change.js and /cart.js. No free-shipping progress bar:
     delivery is free on everything, so a bar would be an invented threshold. */
  var CJSON = document.getElementById('yta-cart-json');
  var seeded = null;
  try { seeded = CJSON ? JSON.parse(CJSON.textContent) : null; } catch (e) { seeded = null; }

  var PJSON = document.getElementById('yta-product-json');
  var PRODUCT = null;
  try { PRODUCT = PJSON ? JSON.parse(PJSON.textContent) : null; } catch (e) { PRODUCT = null; }

  var dq = function (id) { return document.getElementById(id); };
  var cdrawer = dq('cartdrawer'), cscrim = dq('cart-scrim'),
      cbody = dq('cart-body'), cempty = dq('cart-empty'), cfoot = dq('cart-foot'),
      ctotal = dq('cart-total'), ccount = dq('cart-count');

  function push(ev, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: ev }, payload || {}));
    if (typeof fbq === 'function') {
      var map = { add_to_cart: 'AddToCart', view_item: 'ViewContent', begin_checkout: 'InitiateCheckout' };
      if (map[ev]) fbq('track', map[ev], payload || {});
    }
  }
  function money(paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }
  function openCart(open) {
    if (!cdrawer) return;
    cdrawer.classList.toggle('on', open);
    if (cscrim) cscrim.classList.toggle('on', open);
    cdrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { var c = dq('cart-close'); if (c) c.focus(); }
  }

  function paint(cart) {
    if (!cbody) return;
    cbody.innerHTML = '';
    (cart.items || []).forEach(function (l) {
      var row = document.createElement('div');
      row.className = 'cd-line';
      row.innerHTML =
        '<img src="' + (l.image || '') + '" alt="">' +
        '<div><p class="nm">' + l.product_title + '</p>' +
        '<p class="vr">' + (l.variant_title || '').split(' - ')[0] + '</p>' +
        '<p class="ben">Ready to eat, nothing added</p>' +
        '<div class="cd-qty">' +
          '<button type="button" data-key="' + l.key + '" data-q="' + (l.quantity - 1) + '" aria-label="Decrease">-</button>' +
          '<span>' + l.quantity + '</span>' +
          '<button type="button" data-key="' + l.key + '" data-q="' + (l.quantity + 1) + '" aria-label="Increase">+</button>' +
        '</div></div>' +
        '<div><p class="pr num">' + money(l.final_line_price) + '</p>' +
        '<button class="rm" type="button" data-key="' + l.key + '" data-q="0">Remove</button></div>';
      cbody.appendChild(row);
    });
    var empty = !cart.item_count;
    cbody.style.display = empty ? 'none' : '';
    if (cempty) cempty.classList.toggle('on', empty);
    if (cfoot) cfoot.classList.toggle('off', empty);
    if (ctotal) ctotal.textContent = money(cart.total_price || 0);
    if (ccount) ccount.textContent = cart.item_count || 0;
    var ob = dq('cart-open');
    if (ob) ob.setAttribute('aria-label', 'Cart, ' + (cart.item_count || 0) + ' items');
  }

  function setBusy(on) {
    if (!cbody) return;
    cbody.classList.toggle('busy', on);
  }
  function cartError() {
    if (!cbody) return;
    cbody.style.display = '';
    cbody.innerHTML = '<p class="cd-err">Could not load your cart just now. ' +
      '<a href="/cart">Open the cart page</a> instead.</p>';
    if (cempty) cempty.classList.remove('on');
    if (cfoot) cfoot.classList.add('off');
  }
  /* Never gate the drawer on a request. Open it, then fill it.
     The old version fetched first and swallowed errors, so a slow or failing
     /cart.js left the drawer permanently shut. */
  function refresh(open) {
    if (open) openCart(true);
    // only show the loading state when there is nothing painted yet; a background
    // reconcile must not flash "Loading" over a cart the shopper is already reading
    var hasContent = cbody && cbody.querySelector('.cd-line');
    if (!hasContent) setBusy(true);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (c) { setBusy(false); paint(c); return c; })
      .catch(function () { setBusy(false); if (!hasContent) cartError(); });
  }

  function currentVariantId() {
    var v = document.querySelector('.varrow .var[aria-pressed="true"]');
    if (v && v.dataset.variantId) return v.dataset.variantId;
    var a = dq('atc');
    return a ? a.dataset.variantId : null;
  }
  function currentQty() {
    var q = document.querySelector('.pdp-buy .qty .q');
    return q ? (parseInt(q.textContent, 10) || 1) : 1;
  }

  function addToCart(id, qty, btn) {
    if (!id) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
    .then(function (res) {
      if (btn) {
        btn.disabled = false;
        btn.textContent = res.ok ? 'Added' : 'Try again';
        setTimeout(function () { btn.textContent = label; }, 1200);
      }
      if (!res.ok) return;
      push('add_to_cart', { currency: 'INR', items: [{ item_id: id, quantity: qty }] });
      refresh(true);
    })
    .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }

  document.querySelectorAll('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var qty = btn.dataset.from === 'sticky' ? 1 : currentQty();
      addToCart(btn.dataset.variantId || currentVariantId(), qty, btn);
    });
  });

  var bundleBtn = dq('add-bundle');
  if (bundleBtn && PRODUCT) bundleBtn.addEventListener('click', function () {
    var items = PRODUCT.variants.filter(function (v) { return v.available; })
                                .map(function (v) { return { id: v.id, quantity: 1 }; });
    if (!items.length) return;
    bundleBtn.disabled = true;
    fetch('/cart/add.js', { method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }) })
      .then(function () { bundleBtn.disabled = false; refresh(true); });
  });

  if (cbody) cbody.addEventListener('click', function (e) {
    var t = e.target.closest('[data-key]');
    if (!t) return;
    fetch('/cart/change.js', { method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: t.dataset.key, quantity: Number(t.dataset.q) }) })
      .then(function (r) { return r.json(); })
      .then(paint);
  });

  var ob2 = dq('cart-open'), cb2 = dq('cart-close');
  if (ob2) ob2.addEventListener('click', function () {
    openCart(true);              // instant, no waiting
    refresh(false);              // then reconcile against the server in the background
  });
  if (cb2) cb2.addEventListener('click', function () { openCart(false); });
  if (cscrim) cscrim.addEventListener('click', function () { openCart(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cdrawer && cdrawer.classList.contains('on')) openCart(false);
  });

  /* coupon: collapsed link, cart only. Shopify validates the code at checkout. */
  var ct = dq('code-toggle'), cr = dq('code-row'), cm = dq('code-msg'), ca = dq('code-apply');
  if (ct && cr) ct.addEventListener('click', function () {
    var open = cr.hasAttribute('hidden');
    if (open) cr.removeAttribute('hidden'); else cr.setAttribute('hidden', '');
    ct.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) dq('code-in').focus();
  });
  if (ca) ca.addEventListener('click', function () {
    var v = (dq('code-in').value || '').trim();
    if (!v) { cm.className = 'code-msg err'; cm.textContent = 'Enter a code first.'; return; }
    cm.className = 'code-msg ok';
    cm.textContent = 'Code will be applied at checkout.';
    window.location.href = '/discount/' + encodeURIComponent(v) + '?redirect=/checkout';
  });

  var co = dq('checkout');
  if (co) co.addEventListener('click', function () {
    push('begin_checkout', { currency: 'INR' });
    window.location.href = '/checkout';
  });

  /* variant switching updates price, per-unit and the add-to-cart target */
  document.querySelectorAll('.varrow .var').forEach(function (v) {
    v.addEventListener('click', function () {
      document.querySelectorAll('.varrow .var').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      v.setAttribute('aria-pressed', 'true');
      var price = dq('price'), per = dq('per100'), atc = dq('atc'),
          sv = dq('sticky-var'), sp = dq('sticky-price');
      if (price && price.childNodes[0]) price.childNodes[0].nodeValue = v.dataset.priceMoney + ' ';
      if (per) per.innerHTML = v.dataset.per + ' &middot; inclusive of all taxes &middot; free delivery';
      if (atc) atc.dataset.variantId = v.dataset.variantId;
      if (sv) sv.textContent = v.dataset.pack;
      if (sp) sp.innerHTML = v.dataset.priceMoney;
      if (history.replaceState) history.replaceState(null, '', '?variant=' + v.dataset.variantId);
      push('select_item', { item_variant: v.dataset.pack });
    });
  });

  if (seeded) { paint(seeded); } else { refresh(false); }

  if (document.querySelector('.pdp-buy') && PRODUCT) {
    push('view_item', { currency: 'INR', items: [{ item_id: PRODUCT.id, item_name: PRODUCT.title }] });
  }

  /* ---- newsletter capture, with real validation states ---- */
  document.querySelectorAll('form.capture-form').forEach(function (form) {
    var input = form.querySelector('input[type="email"]'),
        msg = form.querySelector('.form-msg');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (input.value || '').trim();
      msg.className = 'form-msg';
      if (!v) { msg.className = 'form-msg err'; msg.textContent = 'Enter your email address so we can reach you.'; input.focus(); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { msg.className = 'form-msg err'; msg.textContent = 'That email does not look right. Check it and try again.'; input.focus(); return; }
      msg.className = 'form-msg ok';
      msg.textContent = 'You are on the list. We will write when the subscription opens.';
      form.querySelector('button').disabled = true;
      input.disabled = true;
    });
  });
})();
